import { RichText } from '@wordpress/block-editor';
import { useContext } from "@wordpress/element";
import BlockContext from '../context/blockContext';

const ProfileInfo = () => {
    const { attributes, setAttributes, currentData, updateDataByStyleField } = useContext(BlockContext);
    const { firstName, lastName, designation } = attributes;
    return (
        <div className="profile-info">
            <div className="bwdcv-name-wrap">
                <RichText
                    tagName="span"
                    className="first-name"
                    value={ currentData.firstName }
                    onChange={(value) => updateDataByStyleField('firstName', value)}
                    placeholder='Enter first name...'
                />
                <RichText
                    tagName="span"
                    className="last-name"
                    value={ currentData.lastName }
                    onChange={(value) => updateDataByStyleField('lastName', value)}
                    placeholder='Enter last name...'
                />
            </div>
            <RichText
                className="designation"
                value={ currentData.designation }
                onChange={(value) => updateDataByStyleField('designation', value)}
                placeholder='Enter designation...'
                />            
        </div>
    )
}

export default ProfileInfo
